<!------------------------------

      Page Actions

------------------------------->

<div *sbPageAction>
  <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
             classes="btn-default actionButtonMinWidth" (click)="requestDebounced()" [disabled]="loading"
             [loading]="loading">
    <sb-icon icon="refresh"></sb-icon>
  </sb-button>
  <sb-button *ngIf="DEBUGGING" container="body" ngbTooltip="CHECK ALL" placement="top"
             classes="btn-secondary actionButtonMinWidth"
             (click)="checkAll()" [disabled]="loading" [loading]="loading">
    <sb-icon icon="checked"></sb-icon>
  </sb-button>
</div>


<!------------------------------

    Table Wrapper

------------------------------->

<sb-table-wrapper headline="{{'lang.headlines.notifications' | translate}}" [itemsData]="notifications"
                  [options]="options" (optionsChange)="requestDebounced($event)" [loading]="loading"
                  [itemName]="'notifications'"
                  [showExactMatch]="true">

  <!------------------------------

    Header More

------------------------------->


  <div header-more>
    <div class="d-flex align-items-center">
      <sb-multi-dropdown [data]="initialToggles" (dataChange)="toggleChange($event)"
                         headline="{{'lang.globals.filterAttributes' | translate}}"></sb-multi-dropdown>
      <sb-comp-dropdown-select
        *ngPermissions="permissionService.Permission.notification_list"
        [showSubmit]="true"
        [inputData]="notificationCategories" [dropDownDatatype]="'NOTIFICATION_CATEGORIES'"
        (selectedDataEmitter)="update($event, 'NOTIFICATION_CATEGORIES')" [showColumnIcon]="false"
        [msOptions]="msCategoryOptions" (msOptionsChange)="msRequest('NOTIFICATION_CATEGORIES', $event)"
        [selectedInputData]="filteredCategories ? filteredCategories : []">
      </sb-comp-dropdown-select>
    </div>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        #
      </th>
      <th>
        {{'lang.globals.severity' | translate}}
      </th>
      <th>
        {{'lang.globals.title' | translate}}
      </th>
      <th>
        {{'lang.globals.status' | translate}}
      </th>
      <th>
        {{'lang.globals.message' | translate}}
      </th>
      <th>
        {{'lang.globals.created' | translate}}
      </th>
      <th>
        {{'lang.globals.checked' | translate}}
      </th>
      <th>
        {{'lang.globals.archived' | translate}}
      </th>
      <th class="tr">

      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-notification>
    <tr>
      <td>
        {{notification.id}}
      </td>
      <td>
        <ng-container [ngSwitch]="notification.logLevel">
          <sb-icon *ngSwitchCase="'info'" icon="details" class="blue"></sb-icon>
          <sb-icon *ngSwitchCase="'warning'" icon="attention" class="yellow"></sb-icon>
          <sb-icon *ngSwitchCase="'error'" icon="error" class="red"></sb-icon>
          <sb-icon *ngSwitchDefault icon="questionmark"></sb-icon>
        </ng-container>
      </td>
      <td [innerHTML]="notification.name | truncate : 30">
      </td>
      <td>
        {{notification.status}}
      </td>
      <td>
        <p class="font-weight-bold m-0" [innerHTML]="notification.message | truncate : 30"></p>
      </td>
      <td>
        {{notification.createdAt | date:'dd.MM.yy HH:mm'}}
      </td>
      <td>
        <a class="link" container="body"
           ngbTooltip="{{'lang.globals.checkedBy' | translate}}: {{notification?.checkedBy?.name ? notification?.checkedBy?.name : ('lang.globals.unknown'|translate)}}"
           placement="top">
          {{notification?.checked?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
        </a>
      </td>
      <td>
        <a class="link" container="body"
           ngbTooltip="{{'lang.globals.archivedBy' | translate}}: {{notification?.archivedBy?.name ? notification?.archivedBy?.name : ('lang.globals.unknown'|translate)}}"
           placement="top">
          {{notification?.archived?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
        </a>
      </td>
      <td class="tr sticky-col last-col tableBg">
        <sb-table-buttons>
          <ng-container *ngIf="!notification.checked">
            <a ngbTooltip="{{'lang.notifications.markAsRead' | translate}}" placement="top" container="body"
               *ngPermissions="[permissionService.Permission.notification_read]"
               (click)="check(notification)" class="btn btn-success">
              <sb-icon icon="success"></sb-icon>
            </a>
          </ng-container>
          <ng-container *ngIf="!notification.archived">
            <a ngbTooltip="{{'lang.globals.archive' | translate}}" placement="top" container="body"
               *ngPermissions="[permissionService.Permission.notification_archive]"
               (click)="archive(notification)" class="btn btn-primary">
              <sb-icon icon="archive"></sb-icon>
            </a>
          </ng-container>
        </sb-table-buttons>
      </td>
    </tr>
  </ng-template>

  <!---------------------------------------

  Card element

  ----------------------------------->

  <!-- no card element -->

</sb-table-wrapper>
